export const Dota = {
  id: 18,
  height: 5889387,
  data: {
    icon: "/imgs/icons/asset/dota.svg",
    about:
      "Building the first scalable inscription protocol standard on Polkadot.",
    links: [
      {
        name: "Link",
        url: "https://dotispink.com/",
      },
      {
        name: "Twitter/x",
        url: "https://twitter.com/dot20_dota",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Github",
        url: "https://github.com/DOTA-DOT20",
        icon: "/imgs/icons/link-github.svg",
        darkIcon: "/imgs/icons/link-github-dark.svg",
      },
      {
        name: "Gitbook",
        url: "https://docs.dota.fyi/",
        icon: "/imgs/icons/link-gitbook.svg",
      },
    ],
  },
};
